import React from 'react';

const SVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
    <path d="M31.557 12.067L31.773 0 19.791.213l.05 3.216 6.225-.115-7.347 7.39 2.422 2.434 7.34-7.382-.108 6.213 3.184.098zM.215 19.903L0 31.97l11.984-.213-.05-3.217-6.225.113 7.348-7.388-2.42-2.436-7.34 7.383L3.402 20l-3.187-.098zM20.004 31.704L32 32.001l-.293-12.059-3.195.03.154 6.263-7.396-7.44-2.407 2.42 7.389 7.43-6.174-.148-.074 3.207zM12.213.33L.22.034l.293 12.059 3.195-.032-.152-6.26 7.394 7.438 2.404-2.418L5.967 3.39l6.174.15.072-3.209z" />
  </svg>
);
export default SVG;
